// generated by docker build
export const appConfig = {    
  editorBucketNameParameterPath: "/stg/architect-io/bucket/editor",
  reviewerBucketNameParameterPath: "/stg/architect-io/bucket/reviewer",
  publishedBucketNameParameterPath: "/stg/architect-io/bucket/published",
  publishToReviewLambdaParameterPath: "/stg/architect-io/lambda/publish-to-review",
  publishLambdaParameterPath: "/stg/architect-io/lambda/publish",
}
